<template>
  <div :class="divClassName ? divClassName : ''">
    <a
      :href="'https://www.tiktok.com/@' + tiktokHandle"
      target="_blank"
      v-if="isTikTok"
    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{tiktokHandle}}</a>
    <a
      @click="openLink('http://instagram.com/' + instagramHandle)"
      v-if="isInstagram"
    ><v-icon small style="color:#E1306C !important;">mdi-instagram</v-icon> @{{instagramHandle}}</a>   
    <a
      :href="'https://facebook.com/' + facebookHandle"
      target="_blank"
      v-if="isFacebook && facebookHandle"
    ><v-icon small style="color:#1877F2 !important;">mdi-facebook</v-icon> @{{facebookHandle}}</a>
    <a
      :href="'https://www.linkedin.com/in/' + linkedinHandle"
      target="_blank"
      rel="noopener noreferrer"
      v-if="isLinkedIn && linkedinHandle"
    ><v-icon small style="color:#0A66C2 !important;">mdi-linkedin</v-icon> @{{linkedinHandle}}</a>
    <a
      :href="'https://x.com/' + twitterHandle"
      target="_blank"
      rel="noopener noreferrer"
      v-if="isTwitter && twitterHandle"
    ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{twitterHandle}}</a>
    <a
      :href="showYoutubeURL(youtubeURL)"
      target="_blank"
      v-if="isYoutube"
    ><v-icon small style="color:#FF0000 !important;">mdi-youtube</v-icon> @{{youtubeHandle}}</a>
    <a
      @click="openLink('https://www.xiaohongshu.com/user/profile/' + xiaohongshuHandle)"
      v-if="isXiaohongshu"
    ><img src="/static/img/xhs-black.png" width="20px" /> {{xiaohongshuFullName || xiaohongshuHandle}}</a>
    <a v-if="isOthers"><v-icon small style="color:#616161 !important;">mdi-help-circle</v-icon> {{otherHandle}}</a>
  </div>
</template>
<script>
  export default {
    name: 'SocialHandle',
    props: [
      'isTikTok',
      'isInstagram',
      'isFacebook',
      'isLinkedIn',
      'isTwitter',
      'tiktokHandle',
      'instagramHandle',
      'facebookHandle',
      'linkedinHandle',
      'twitterHandle',
      'divClassName',
      'isYoutube',
      'youtubeHandle',
      'youtubeURL',
      'isXiaohongshu',
      'xiaohongshuHandle',
      'xiaohongshuFullName',
      'isOthers',
      'otherHandle'
    ],
    methods: {
      showYoutubeURL(youtubeURL) {
        if (youtubeURL && youtubeURL.includes('https://www.youtube.com')) {
          return youtubeURL
        } else {
          return 'https://youtube.com/@' + this.youtubeHandle
        }
      },
      openLink(link) {
        window.open(link, '_blank')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SocialHandle.vue?6af57b20